import { CircularProgress } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import { format, isToday, isTomorrow } from 'date-fns'
import {
  Bike, CheckCircle, Copy, CreditCard, DollarSign, Edit, FileText,
  Package, PenTool, Plus, QrCode, RefreshCw, Scissors, Share,
  ShoppingCart, Trash2, Truck, Undo, User, Zap, ChevronUp, MoreHorizontal,
} from 'lucide-react'
import React, { useEffect, useMemo, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import ModernOrdersNavbar from './buttons.jsx'
import ModernFiltersCard from './cardMenu.jsx'
import ModalTable from './modalDev.jsx'
import ModalProduct from './modalProduto.jsx'
import OrdersTable from './ordersTable.jsx'
import {
  Tooltip as BootstrapTooltip, Form, FormCheck, Modal, OverlayTrigger, Spinner,
} from 'react-bootstrap'
import { ArrowDownCircleFill, ArrowUpCircleFill, CircleFill } from 'react-bootstrap-icons'
import 'react-datepicker/dist/react-datepicker.css'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import ReactTooltip from 'react-tooltip-lite'
import swal from 'sweetalert'
import shopeeLogo from '../../assets/shopeeLogo.png'
import { CustomButton } from '../../components/CustomButton/index.jsx'
import { CustomSpinner } from '../../components/CustomSpinner/index.jsx'
import Navbar from '../../components/navbar/navbar'
import { useOrdenation } from '../../hooks/useOrdenation/index.js'
import apinode from '../../services/apinode'
import FuncionariosService from '../../services/database/FuncionariosService'
import PedidosService from '../../services/database/PedidosService'
import { formatPrice } from '../../utils/formatPrice.js'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import ModalHistoricoPedido from './modal.jsx'
import { ModalRangeDatePicker } from './ModalRangeDatePicker/index.jsx'
import PagamentosModal from './ModalRecebimento.jsx'
import './pedidoscss.css'

/* ─────────────────────────────────────────────────────────────────────────── */
/*  ESTILOS GLOBAIS — estilo Tiny ERP (fundo cinza claro, tabela branca clean) */
/* ─────────────────────────────────────────────────────────────────────────── */
const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,300;0,14..32,400;0,14..32,500;0,14..32,600;0,14..32,700&display=swap');

    /* ── Reset base ── */
    .tn * { font-family: 'Inter', system-ui, sans-serif !important; box-sizing: border-box; }
    .tn {
      background: #f0f2f5;
      min-height: 100vh;
      padding: 0 20px 48px;
    }

    /* ── Card principal ── */
    .tn-card {
      background: #fff;
      border: 1px solid #dde1e7;
      border-radius: 8px;
      overflow: hidden;
      margin-top: 18px;
      box-shadow: 0 1px 4px rgba(0,0,0,0.06);
    }

    /* ── Barra de total (admin) ── */
    .tn-total-bar {
      background: #fffbeb;
      border-bottom: 1px solid #fde68a;
      padding: 6px 16px;
      font-size: 12px;
      font-weight: 600;
      color: #92400e;
      display: flex;
      align-items: center;
      gap: 6px;
    }

    /* ── Toolbar ── */
    .tn-toolbar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 14px;
      background: #f8f9fb;
      border-bottom: 1px solid #dde1e7;
      gap: 10px;
      flex-wrap: wrap;
    }
    .tn-count {
      font-size: 12px;
      color: #6b7280;
      background: #fff;
      border: 1px solid #e5e7eb;
      padding: 3px 10px;
      border-radius: 4px;
    }
    .tn-count strong { color: #111827; font-weight: 600; }
    .tn-version-sel {
      font-size: 12px; height: 30px; padding: 0 10px;
      border: 1px solid #d1d5db; border-radius: 5px;
      color: #374151; background: #fff; cursor: pointer;
    }
    .tn-version-sel:focus { outline: none; border-color: #2563eb; box-shadow: 0 0 0 2px rgba(37,99,235,.12); }

    /* ── TABELA ── */
    .tn-table { width: 100%; border-collapse: collapse; font-size: 12px; }

    .tn-table thead tr {
      background: #f3f4f6;
      border-bottom: 2px solid #e5e7eb;
    }
    .tn-table thead th {
      padding: 8px 12px;
      font-size: 11px;
      font-weight: 600;
      color: #6b7280;
      text-transform: uppercase;
      letter-spacing: .05em;
      white-space: nowrap;
      border: none;
      user-select: none;
    }

    .tn-table tbody tr { border-bottom: 1px solid #f3f4f6; transition: background .1s; }
    .tn-table tbody tr:last-child { border-bottom: none; }
    .tn-table tbody tr:hover { background: #f0f4ff; }
    .tn-table tbody tr.tn-exp-row { background: #f8f9fb; }
    .tn-table tbody tr.tn-exp-row:hover { background: #f0f2f8; }

    .tn-table td { padding: 8px 12px; vertical-align: middle; border: none; }

    /* ── Checkbox ── */
    .tn-table .form-check-input {
      width: 14px; height: 14px; cursor: pointer;
      accent-color: #2563eb; margin: 0;
    }

    /* ── Botões de ação ── */
    .tn-btn {
      display: inline-flex; align-items: center; justify-content: center;
      width: 26px; height: 26px; border-radius: 4px;
      border: 1px solid #d1d5db; background: #fff;
      color: #6b7280; cursor: pointer; padding: 0;
      text-decoration: none; flex-shrink: 0;
      transition: background .12s, border-color .12s, color .12s, box-shadow .12s;
    }
    .tn-btn:hover {
      background: #2563eb; border-color: #2563eb; color: #fff;
      box-shadow: 0 2px 6px rgba(37,99,235,.3);
    }
    .tn-btn.tn-active {
      background: #2563eb; border-color: #2563eb; color: #fff;
    }
    .tn-btn.tn-danger:hover {
      background: #dc2626; border-color: #dc2626;
      box-shadow: 0 2px 6px rgba(220,38,38,.3);
    }
    .tn-btn.tn-ok:hover {
      background: #16a34a; border-color: #16a34a;
      box-shadow: 0 2px 6px rgba(22,163,74,.3);
    }

    /* ── Painel expandido ── */
    .tn-more {
      background: #f8f9fb;
      border-top: 1px solid #e9eaed;
      padding: 8px 14px;
      display: flex; align-items: center; gap: 5px; flex-wrap: wrap;
    }
    .tn-more-lbl {
      font-size: 10px; font-weight: 600; text-transform: uppercase;
      letter-spacing: .06em; color: #9ca3af; margin-right: 2px;
    }
    .tn-sep { width: 1px; height: 18px; background: #e5e7eb; margin: 0 3px; flex-shrink: 0; }

    /* ── Badges ── */
    .tb {
      display: inline-flex; align-items: center; gap: 3px;
      font-size: 10px; font-weight: 600;
      padding: 2px 7px; border-radius: 3px;
      white-space: nowrap; line-height: 1.6;
    }
    .tb-green  { background: #dcfce7; color: #166534; }
    .tb-red    { background: #fee2e2; color: #991b1b; }
    .tb-blue   { background: #dbeafe; color: #1e40af; }
    .tb-yellow { background: #fef9c3; color: #854d0e; }
    .tb-gray   { background: #f3f4f6; color: #374151; border: 1px solid #e5e7eb; }
    .tb-purple { background: #ede9fe; color: #5b21b6; }
    .tb-orange { background: #ffedd5; color: #9a3412; }
    .tb-teal   { background: #ccfbf1; color: #115e59; }

    /* ── Células ── */
    .tn-pedido { font-weight: 700; font-size: 12px; color: #2563eb; }
    .tn-cliente { font-size: 12px; font-weight: 500; color: #111827; max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block; }
    .tn-valor { font-size: 13px; font-weight: 700; color: #111827; white-space: nowrap; }
    .tn-date { font-size: 12px; font-weight: 500; color: #374151; }
    .tn-time { font-size: 11px; color: #9ca3af; margin-top: 1px; }
    .tn-extid { font-size: 11px; color: #6b7280; cursor: pointer; transition: color .1s; }
    .tn-extid:hover { color: #2563eb; text-decoration: underline; }
    .tn-conf { font-size: 11px; font-weight: 500; color: #374151; }
    .tn-conf-dt { font-size: 10px; color: #9ca3af; margin-top: 2px; }

    /* ── Indicador $  ── */
    .tn-dollar {
      width: 22px; height: 22px; border-radius: 50%;
      display: inline-flex; align-items: center; justify-content: center; cursor: pointer;
    }
    .tn-dollar.ok  { background: #dcfce7; }
    .tn-dollar.nok { background: #fee2e2; }

    /* ── Loader / empty ── */
    .tn-loader { display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 60px; color: #9ca3af; font-size: 13px; }
    .tn-loader .spinner-border { width: 22px; height: 22px; border-width: 2px; color: #2563eb; }
    .tn-empty { text-align: center; padding: 50px; color: #9ca3af; font-size: 13px; }

    /* ── Paginação ── */
    .tn .pagination { gap: 2px; }
    .tn .pagination .page-link { font-size: 12px; padding: 4px 9px; border: 1px solid #e5e7eb; border-radius: 4px; color: #374151; background: #fff; }
    .tn .pagination .page-link:hover { background: #eff6ff; color: #2563eb; border-color: #2563eb; }
    .tn .pagination .page-item.active .page-link { background: #2563eb; border-color: #2563eb; color: #fff; }
    .tn .pagination .page-item.disabled .page-link { color: #d1d5db; }

    /* ── Scroll buttons ── */
    .tn-scrolls { position: fixed; bottom: 20px; right: 20px; z-index: 99999; display: flex; flex-direction: column; gap: 4px; }
    .tn-scroll-btn { width: 30px; height: 30px; border-radius: 6px; background: #fff; border: 1px solid #d1d5db; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #6b7280; box-shadow: 0 2px 6px rgba(0,0,0,.08); transition: all .12s; }
    .tn-scroll-btn:hover { background: #2563eb; color: #fff; border-color: #2563eb; }

    /* ── Modais ── */
    .tn-modal .modal-content { border-radius: 8px; border: 1px solid #dde1e7; font-size: 13px; }
    .tn-modal .modal-header { background: #f8f9fb; border-bottom: 1px solid #e5e7eb; padding: 11px 18px; }
    .tn-modal .modal-title { font-size: 14px; font-weight: 600; color: #111827; }
    .tn-modal .modal-body { padding: 18px; }
    .tn-modal .modal-footer { background: #f8f9fb; border-top: 1px solid #e5e7eb; padding: 10px 18px; }
    .tn-modal label { font-size: 11px; font-weight: 600; color: #6b7280; margin-bottom: 5px; display: block; text-transform: uppercase; letter-spacing: .04em; }
    .tn-modal select, .tn-modal .form-select { font-size: 13px; border: 1px solid #d1d5db; border-radius: 5px; padding: 7px 10px; color: #374151; }
    .tn-modal select:focus, .tn-modal .form-select:focus { border-color: #2563eb; box-shadow: 0 0 0 2px rgba(37,99,235,.12); outline: none; }

    /* ── Shopee btns ── */
    .shopee-action-btn {
      font-size: 12px; font-weight: 500; padding: 6px 14px; border-radius: 5px;
      border: 1px solid #d1d5db; background: #fff; color: #374151; cursor: pointer;
      display: inline-flex; align-items: center; gap: 6px; transition: all .12s;
    }
    .shopee-action-btn:hover { background: #ee4d2d; color: #fff; border-color: #ee4d2d; }
    .shopee-action-btn:disabled { opacity: .5; cursor: not-allowed; }

    /* ── MUI tooltip override ── */
    .MuiTooltip-tooltip { font-size: 11px !important; background: #1f2937 !important; border-radius: 4px !important; }

    @media (max-width: 768px) {
      .tn { padding: 0 10px 40px; }
      .tn-table td, .tn-table th { padding: 7px 8px; }
      .tn-cliente { max-width: 120px; }
    }
  `}</style>
)

/* ─── Funções auxiliares de badge ─────────────────────────────────────────── */
const tipoBadgeClass = (tipo) => {
  if (!tipo) return 'tb tb-gray'
  const t = tipo.toLowerCase()
  if (t === 'venda') return 'tb tb-green'
  if (t === 'reposicao') return 'tb tb-blue'
  if (t === 'condicional') return 'tb tb-orange'
  return 'tb tb-gray'
}

const statusBadgeClass = (status) => ({
  'Atendido': 'tb tb-green', 'Cancelado': 'tb tb-red',
  'Ag. Conf.': 'tb tb-blue', 'Ag. conf.': 'tb tb-blue',
  'ERRO IMPRESSAO': 'tb tb-yellow', 'Em aberto': 'tb tb-yellow',
  'Em conferência': 'tb tb-purple', 'Atrasado': 'tb tb-red',
  'Pago': 'tb tb-teal', 'Boleto': 'tb tb-orange',
}[status] || 'tb tb-gray')

const substatusBadgeClass = (s) => ({
  waiting_for_carrier_authorization: 'tb tb-yellow',
  invoice_pending: 'tb tb-red',
  dropped_off: 'tb tb-green',
  picked_up: 'tb tb-blue',
  ready_to_ship: 'tb tb-blue',
  under_review: 'tb tb-gray',
}[s] || 'tb tb-teal')

/* ─────────────────────────────────────────────────────────────────────────── */
function OrderListM() {
  const [orders, setOrders] = useState([])
  const [funcionario, setFuncionario] = useState()
  const [isLoading, setLoading] = useState(true)
  const [selectedOrders, setSelectedOrders] = useState([])
  const [logs, setLogs] = useState([])
  const [showLogModal, setShowLogModal] = useState(false)
  const [selectedRange, setSelectedRange] = useState(null)
  const [conta, setConta] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [showModalMr, setShowModalMr] = useState(false)
  const [atualizarStatus, setAtualizarStatus] = useState('')
  const [pedido, setPedido] = useState(null)
  const [showModalShopee, setShowModalShopee] = useState(false)
  const [pedidoShopee, setPedidoShopee] = useState('')
  const [lojaShopee, setLojaShopee] = useState('')
  const [idship, setIdship] = useState('')
  const [isLoadingS, setLoadingS] = useState(false)
  const [historico, setHistoricoModal] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [isModalRangeDatePickerOpen, setIsModalRangeDatePickerOpen] = useState(false)
  const [loadingEstorno, setLoadingEstorno] = useState(false)
  const [showModalDev, setShowModaldev] = useState(false)
  const [isUnifyOrdersLoading, setIsUnifyOrdersLoading] = useState(false)
  const [isExportOrderLoading, setIsExportOrderLoading] = useState({})
  const [isOrderCopied, setIsOrderCopied] = useState({})
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [orderMoreAction, setOrderMoreAction] = useState({})
  const isMobile = useMediaQuery({ maxWidth: 768 })
  const [tableVersion, setTableVersion] = useState('v1')
  const effectiveVersion = isMobile ? 'v1' : tableVersion
  const [loadingEstruturar, setLoadingEstruturar] = useState(null)

  const handleOpenModal = (order) => { setSelectedOrder(order); setModalOpen(true) }
  const handleCloseModal = () => setModalOpen(false)
  const [dadosDev, setDadosDev] = useState([])
  const handleCloseDev = () => setShowModaldev(false)
  const [showModalHist, setShowModalHist] = useState(false)

  const handleHistorico = async (ped) => {
    try {
      const r = await apinode.get(`/pedido/historico/${ped}/${localStorage.idconta}`)
      setPedido(ped); setHistoricoModal(r.data); setShowModalHist(true)
    } catch (e) { console.error(e) }
  }

  async function copyLinkSignature(ped) {
    const url = new URL(document.URL)
    setIsOrderCopied((p) => ({ ...p, [ped]: true }))
    await navigator.clipboard.writeText(`${url.origin}/signature-order?order=${ped}&conta=${localStorage.idconta}`)
    setTimeout(() => setIsOrderCopied((p) => ({ ...p, [ped]: false })), 5000)
  }

  const atualizarHistorico = async (ped) => {
    try {
      const r = await apinode.get(`/pedido/historico/${ped}/${localStorage.idconta}`)
      setHistoricoModal(r.data); setShowModalHist(true)
    } catch (e) { console.error(e) }
  }

  const handleFecharModal = () => setShowModalHist(false)
  const handleNfe = (_loja, idnfe) => window.open(`/nfe/editar/${idnfe}`, '_blank')

  const { filteredItems, itemsPerPage, setItemsPerPage, Th, Paginate } = useOrdenation(orders, 'PEDIDO')

  const handleEstorno = async (order) => {
    if (!window.confirm('Tem certeza que deseja estornar este pedido?')) return
    try {
      setLoadingEstorno((p) => ({ ...p, [order]: true }))
      const r = await apinode.get(`/pedido/estornoPedido/${order}/${localStorage.idconta}`, { params: { pedido: order } })
      if (r.status === 200) { toast.success(r.data.message); setPedido('') }
      else { toast.error('Erro ao solicitar estorno.'); setPedido('') }
    } catch { toast.error('Erro ao solicitar estorno.'); setPedido('') }
    finally { setLoadingEstorno((p) => ({ ...p, [order]: false })) }
  }

  const handleParcial = async (order) => {
    try {
      const r = await apinode.get(`/devolucoes/listar/${order}/${localStorage.idconta}`)
      if (r.status === 200) { setDadosDev(r.data); setShowModaldev(true) }
      else toast.error('Erro ao listar devoluções.')
    } catch { toast.error('Erro ao realizar solicitação.') }
  }

  const handleEstruturar = async (order) => {
    try {
      setLoadingEstruturar(order)

      const r = await apinode.get(
        `/pedido/restruturar/${localStorage.idconta}`,
        { params: { pedido: order } }
      )

      if (r.status === 200) {
        toast.success(r.data.message)
        setPedido('')
      } else {
        toast.error('Erro ao reestruturar.')
        setPedido('')
      }
    } catch (e) {
      toast.error(
        e.response?.status === 403
          ? 'Pedido com itens conferidos. Realize o estorno primeiro.'
          : 'Erro ao reestruturar.'
      )
      setPedido('')
    } finally {
      setLoadingEstruturar(null)
    }
  }

  const handleOrderSelection = (order) => {
    const isSel = selectedOrders.some((s) => s.PEDIDO === order.PEDIDO)
    if (isSel) setSelectedOrders(selectedOrders.filter((s) => s.PEDIDO !== order.PEDIDO))
    else setSelectedOrders([...selectedOrders, { SHIP: order.SHIP, PEDIDO: order.PEDIDO, SELLER: order.ID_LOJA }])
  }

  async function handleExportOrderToBHDatabase(orderId, index) {
    try {
      setIsExportOrderLoading((p) => ({ ...p, [index]: true }))
      await PedidosService.exportOrderToBelaHomeDatabase(orderId)
      toast.success('Pedido exportado!')
    } catch (err) { sendErrorApiMessage(err, 'Erro ao exportar.') }
    finally { setIsExportOrderLoading((p) => ({ ...p, [index]: false })) }
  }

  const handleRecadastrar = async (order) => {
    if (!window.confirm('Recadastrar cliente deste pedido?')) return
    try {
      const r = await apinode.put(`/pedido/recadastrarclientepedido/${order}/${localStorage.idconta}`)
      if (r.status === 200) { toast.success('Cadastro solicitado!'); setPedido('') }
      else { toast.error('Erro ao solicitar cadastro.'); setPedido('') }
    } catch { toast.error('Erro ao solicitar cadastro.'); setPedido('') }
  }

  const handleOrgShopee = async () => {
    try {
      setLoadingS(true)
      const r = await apinode.get(`/pedido/shopee/organizarcoleta/${localStorage.idconta}`, { params: { seller: lojaShopee, pedido: pedidoShopee } })
      if (r.status === 200) { toast.success(r.data.success); setIdship(r.data.retorno) }
      else toast.error(r.data.error)
    } catch { } finally { setLoadingS(false) }
  }

  const handleCreateEtqShopee = async () => {
    try {
      setLoadingS(true)
      const r = await apinode.get(`/pedido/shopee/criaretiqueta/${localStorage.idconta}`, { params: { seller: lojaShopee, pedido: pedidoShopee } })
      if (r.status === 200) { toast.success('Etiqueta criada!'); setPedido('') }
    } catch { } finally { setLoadingS(false) }
  }

  const handleDownloadEtqShopee = async () => {
    try {
      setLoadingS(true)
      const r = await apinode.get(`/pedido/shopee/download/${localStorage.idconta}`, { params: { seller: lojaShopee, pedido: pedidoShopee } })
      if (r.status === 200) { window.open(`${localStorage.base}/relatorioshopee/${pedidoShopee}/content_declaration.pdf`, '_blank'); toast.success('Etiqueta impressa!') }
      else toast.error('Erro ao emitir etiqueta.')
    } catch (e) { toast.error('Erro: ' + e.message) } finally { setLoadingS(false) }
  }

  const handleUpdate = async () => {
    try {
      await apinode.put(`/pedido/alterstatus/${pedido}/${localStorage.idconta}`, { status: atualizarStatus })
      toast.success('Status alterado!'); buscarDados()
    } catch (e) { sendErrorApiMessage(e, 'Erro ao alterar status') }
    finally { setPedido(''); setShowModal(false) }
  }

  const handleDelete = async (order) => {
    if (!window.confirm('Excluir este pedido?')) return
    setLoading(true)
    try {
      await apinode.delete(`/pedido/${order}/${localStorage.idusuario}/${localStorage.idconta}`)
      toast.success('Pedido excluído!'); await buscarDados()
    } catch (e) {
      toast.error(e.response?.status === 404 ? 'Pedido não encontrado.' : e.request ? 'Sem resposta do servidor.' : 'Erro ao excluir.')
    } finally { setLoading(false) }
  }

  const handleShopee = (order, loja, ship) => { setLojaShopee(loja); setPedidoShopee(order); setIdship(ship); setShowModalShopee(true) }

  async function handleCloneOrder(order) {
    try {
      const r = await apinode.post(`/order/clone/${order.PEDIDO}/${localStorage.idconta}`)
      toast.success(r.data.message); buscarDados()
    } catch (err) { sendErrorApiMessage(err, 'Não foi possível clonar.') }
  }

  async function getFuncionarioData() {
    try { setFuncionario(await FuncionariosService.getById(localStorage.idusuario)) }
    catch (err) { sendErrorApiMessage(err, 'Erro ao buscar funcionário.') }
  }

  async function buscarDados() {
    try {
      setLoading(true)
      const r = await apinode.get(`/pedido/${localStorage.idconta}?idFuncionario=${localStorage.idusuario}`)
      setOrders(r.data)
    } catch { swal('Ops!', 'Erro ao buscar pedidos', 'warning') }
    finally { setLoading(false) }
  }

  async function handleUnifyOrders() {
    try {
      setIsUnifyOrdersLoading(true)
      toast.success(await PedidosService.unifyOrders(selectedOrders)); buscarDados()
    } catch (err) { sendErrorApiMessage(err, 'Não foi possível unificar.') }
    finally { setIsUnifyOrdersLoading(false) }
  }

  const fetchAccounts = async () => {
    try { setConta((await apinode.get(`/pedido/contas/${localStorage.idconta}?`)).data) }
    catch (e) { console.error(e) }
  }

  const totalCusto = useMemo(() => formatPrice(orders.reduce((a, i) => a + i.VALOR, 0)), [orders])

  const statusMap = {
    pending: 'Pendente', handling: 'Em processamento', shipped: 'Enviado', delivered: 'Entregue',
    not_delivered: 'Não entregue', cancelled: 'Cancelado',
    waiting_for_carrier_authorization: 'Ag. transportador', invoice_pending: 'Fatura pendente',
    dropped_off: 'Ponto de coleta', picked_up: 'Coletado', under_review: 'Em revisão',
    ready_to_ship: 'Pronto p/ Envio', ready_for_pickup: 'Pronto p/ coleta', in_warehouse: 'No armazém',
  }

  const getBadgeColorForSubstatus = (s) => ({ waiting_for_carrier_authorization: 'warning', invoice_pending: 'danger', dropped_off: 'success', picked_up: 'primary', ready_to_ship: 'primary', under_review: 'secondary' }[s] || 'success')
  const getStatusBadgeVariant = (s) => ({ 'Atendido': 'success', 'Cancelado': 'danger', 'Ag. Conf.': 'primary', 'ERRO IMPRESSAO': 'warning', 'Em aberto': 'warning' }[s] || 'secondary')
  const formatarDataDespacho = (d) => { const dt = new Date(d); if (isToday(dt)) return 'Hoje'; if (isTomorrow(dt)) return 'Amanhã'; return format(dt, 'dd/MM/yyyy') }

  function scrollToTop() { window.scroll({ top: 0, behavior: 'smooth' }) }
  function scrollToBottom() { window.scroll({ top: document.documentElement.scrollHeight, behavior: 'smooth' }) }

  useEffect(() => { getFuncionarioData(); fetchAccounts(); buscarDados() }, [])

  /* ── Botão reutilizável ── */
  const TBtn = ({ title, onClick, icon, variant = '', disabled = false, href, target, to }) => {
    const cls = `tn-btn${variant === 'danger' ? ' tn-danger' : variant === 'ok' ? ' tn-ok' : ''}`
    if (href) return <a href={href} target={target} rel="noopener noreferrer" className={cls} title={title}>{icon}</a>
    if (to) return <Link to={to} className={cls} title={title}>{icon}</Link>
    return <button className={cls} onClick={onClick} disabled={disabled} title={title}>{disabled ? <CircularProgress size={10} color="inherit" /> : icon}</button>
  }

  /* ── Badge integração ── */
  const IntegBadge = ({ v }) => {
    if (v === 'fulfillment') return <span className="tb tb-green"><Zap size={9} />Full</span>
    if (v === 'cross_docking') return <span className="tb tb-blue"><Truck size={9} />Coleta</span>
    if (v === 'self_service') return <span className="tb tb-yellow"><Bike size={9} />Flex</span>
    return <span className="tb tb-gray">{v}</span>
  }

  /* ── Log Modal ── */
  const LogModal = ({ show, onHide, logs }) => (
    <Modal show={show} onHide={onHide} dialogClassName="tn-modal">
      <Modal.Header closeButton><Modal.Title>Logs de Impressão</Modal.Title></Modal.Header>
      <Modal.Body>
        <ul style={{ paddingLeft: 16, margin: 0 }}>
          {logs.map((l, i) => <li key={i} style={{ color: l.success ? '#166534' : '#991b1b', fontSize: 12, marginBottom: 3 }}>{l.message}</li>)}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <button className="tn-btn" style={{ width: 'auto', padding: '0 14px', height: 30, fontSize: 12 }} onClick={() => { setLogs([]); onHide() }}>Fechar</button>
      </Modal.Footer>
    </Modal>
  )

  return (
    <>
      <GlobalStyles />
      <Navbar />

      <div className="tn mt-page">

        <ModernOrdersNavbar
          selectedOrders={selectedOrders} setSelectedOrders={setSelectedOrders}
          onUnifyOrders={handleUnifyOrders} isUnifyOrdersLoading={isUnifyOrdersLoading}
        />

        {/* Scroll buttons */}
        <div className="tn-scrolls">
          <div className="tn-scroll-btn" onClick={scrollToTop} title="Topo"><ArrowUpCircleFill size={13} /></div>
          <div className="tn-scroll-btn" onClick={scrollToBottom} title="Rodapé"><ArrowDownCircleFill size={13} /></div>
        </div>

        <ModernFiltersCard
          onResults={(dados) => setOrders(dados)}
          onLoadingChange={setLoading}
          onError={() => { }}
          initialPagination={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
        />

        <LogModal show={showLogModal} onHide={() => setShowLogModal(false)} logs={logs} />
        <PagamentosModal showModal={showModalMr} setShowModal={setShowModalMr} pedido={pedido} />

        {/* ── Card da tabela ── */}
        <div className="tn-card">

          {localStorage.admin === 'SIM' && (
            <div className="tn-total-bar">
              <CircleFill color="#b45309" size={7} />
              Total da listagem: <strong style={{ marginLeft: 3 }}>{totalCusto}</strong>
            </div>
          )}

          {!isMobile && (
            <div className="tn-toolbar">
              <span className="tn-count">
                Exibindo <strong>{filteredItems.length}</strong> de <strong>{orders.length}</strong> pedidos
              </span>
              <select value={tableVersion} onChange={(e) => setTableVersion(e.target.value)} className="tn-version-sel">
                <option value="v1">Versão V1</option>
                <option value="v2">Versão V2</option>
              </select>
            </div>
          )}

          {isLoading ? (
            <div className="tn-loader">
              <Spinner animation="border"><span className="visually-hidden">Carregando...</span></Spinner>
              <span>Carregando pedidos...</span>
            </div>
          ) : filteredItems.length === 0 ? (
            <div className="tn-empty">Nenhum resultado encontrado.</div>
          ) : effectiveVersion === 'v1' ? (
            <>
              <div style={{ overflowX: 'auto' }}>
                <table className="tn-table">
                  <thead>
                    <tr>
                      <th style={{ width: 20 }}></th>
                      <th>Ações</th>
                      <th></th>
                      <th>Tipo</th>
                      <th>Data</th>
                      <th>Cliente / Pedido</th>
                      <th>Valor</th>
                      <th>Integração</th>
                      <th>Conferente</th>
                      <th>Loja</th>
                      <th>Order / Ship</th>
                      <th>Impressão / Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredItems.map((order, index) => (
                      <React.Fragment key={order.PEDIDO}>

                        {/* ── Linha principal ── */}
                        <tr>

                          {/* Checkbox */}
                          <td>
                            <FormCheck type="checkbox"
                              checked={selectedOrders.some((s) => s.PEDIDO === order.PEDIDO)}
                              onChange={() => handleOrderSelection(order)}
                            />
                          </td>

                          {/* Ações primárias */}
                          <td>
                            <div style={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                              <Tooltip title="Editar pedido">
                                <a href={`/pedido/editar/${order.PEDIDO}`} target="_blank" rel="noopener noreferrer" className="tn-btn" title="Editar"><Edit size={11} /></a>
                              </Tooltip>
                              <Tooltip title="Alterar Status">
                                <button className="tn-btn" onClick={() => { setShowModal(true); setPedido(order.PEDIDO) }} title="Alterar Status"><PenTool size={11} /></button>
                              </Tooltip>
                              <Tooltip title="Recebimentos">
                                <button className="tn-btn" onClick={() => { setShowModalMr(true); setPedido(order.PEDIDO) }} title="Recebimentos"><CreditCard size={11} /></button>
                              </Tooltip>
                              <Tooltip title="Dados e Expedição">
                                <Link to={`/pedido/${order.PEDIDO}/${localStorage.idconta}`} className="tn-btn" title="Dados e Expedição"><ShoppingCart size={11} /></Link>
                              </Tooltip>
                              <Tooltip title={orderMoreAction[index] ? 'Recolher' : 'Mais ações'}>
                                <button
                                  className={`tn-btn${orderMoreAction[index] ? ' tn-active' : ''}`}
                                  onClick={() => setOrderMoreAction((p) => p[index] ? { [index]: false } : { [index]: true })}
                                  title="Mais ações"
                                >
                                  {orderMoreAction[index] ? <ChevronUp size={11} /> : <MoreHorizontal size={11} />}
                                </button>
                              </Tooltip>
                            </div>
                          </td>

                          {/* Indicador financeiro */}
                          <td>
                            <OverlayTrigger overlay={<BootstrapTooltip>{order.LANC_CONTAS === 'S' ? 'Conta a Receber lançada' : 'Conta a Receber não lançada'}</BootstrapTooltip>}>
                              <div className={`tn-dollar ${order.LANC_CONTAS === 'S' ? 'ok' : 'nok'}`}>
                                <DollarSign size={11} color={order.LANC_CONTAS === 'S' ? '#166534' : '#991b1b'} />
                              </div>
                            </OverlayTrigger>
                          </td>

                          {/* Tipo */}
                          <td>{order.TIPO_PEDIDO && <span className={tipoBadgeClass(order.TIPO_PEDIDO)}>{order.TIPO_PEDIDO}</span>}</td>

                          {/* Data */}
                          <td>
                            <div className="tn-date">{format(new Date(order.DATA), 'dd/MM/yyyy')}</div>
                            {order.HORA_IMPORTACAO && <div className="tn-time">{order.HORA_IMPORTACAO}</div>}
                          </td>

                          {/* Cliente / Pedido */}
                          <td style={{ minWidth: 260, whiteSpace: 'normal' }}>
  <div
    className="tn-cliente"
    title={order.CLIENTE}
    style={{
      whiteSpace: 'normal',
      wordBreak: 'break-all',
      overflowWrap: 'anywhere',
      overflow: 'visible',
      textOverflow: 'unset',
      display: 'block',
      maxWidth: '100%',
      lineHeight: '1.25',
    }}
  >
    {order.CLIENTE}
  </div>

  <div
    style={{
      display: 'flex',
      gap: 4,
      flexWrap: 'wrap',
      marginTop: 4,
      alignItems: 'center',
    }}
  >
    <span className="tn-pedido">#{order.PEDIDO}</span>
    <span className={statusBadgeClass(order.STATUS)}>{order.STATUS}</span>
  </div>

  {order.VENDEDOR && (
    <div style={{ marginTop: 3 }}>
      <span className="tb tb-gray" style={{ fontSize: 10 }}>
        {order.VENDEDOR}
      </span>
    </div>
  )}
</td>

                          {/* Valor */}
                          <td>
                            {order.VALOR !== null
                              ? <span className="tn-valor">{parseFloat(order.VALOR).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                              : <span style={{ color: '#d1d5db' }}>—</span>}
                          </td>

                          {/* Integração */}
                          <td><IntegBadge v={order.INTEGRADO} /></td>

                          {/* Conferente */}
                          <td>
                            {order.CONFERENTE && (
                              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                <User size={10} color="#9ca3af" />
                                <span className="tn-conf">{order.CONFERENTE}</span>
                              </div>
                            )}
                            {order.DATA_CONFERENCIA && <div className="tn-conf-dt">{format(new Date(order.DATA_CONFERENCIA), 'dd/MM/yy HH:mm')}</div>}
                          </td>

                          {/* Loja / ID externo */}
                          <td>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                              <span className="tb tb-blue">{order.APELIDO}</span>
                              <span
                                className="tn-extid"
                                onClick={() => window.open(`https://ziphub.com.br/pedido/${order.IDPEDIDOLOJA}/${process.env.REACT_APP_DATABASE_MATRIZ}`, '_blank')}
                              >{order.IDPEDIDOLOJA}</span>
                            </div>
                          </td>

                          {/* Order / Ship */}
                          <td>
                            <ReactTooltip
                              content={<div style={{ fontSize: 11 }}><div>Order: {order.IDPEDIDOLOJA}</div><div>Ship: {order.SHIP}</div></div>}
                              direction="left" background="#1f2937"
                            >
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                <span className="tb tb-gray" style={{ fontFamily: 'monospace', fontSize: 10 }}>{order.IDPEDIDOLOJA}</span>
                                <span className="tb tb-gray" style={{ fontFamily: 'monospace', fontSize: 10 }}>{order.SHIP}</span>
                              </div>
                            </ReactTooltip>
                          </td>

                          {/* Status impressão */}
                          <td>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                              <span className={`tb ${order.IMPRESSO === 'S' ? 'tb-green' : 'tb-gray'}`}>
                                {order.IMPRESSO === 'S' ? 'Impresso' : (order.IMPRESSO || 'Não impresso')}
                              </span>
                              {order.SHIP_SUBSTATUS && <span className={substatusBadgeClass(order.SHIP_SUBSTATUS)}>{statusMap[order.SHIP_SUBSTATUS] ?? order.SHIP_SUBSTATUS}</span>}
                              {order.SHIP_DESPACHO && <span className="tb tb-gray">{statusMap[order.SHIP_DESPACHO] ?? order.SHIP_DESPACHO}</span>}
                              {order.DATADESPACHO && <span className="tb tb-gray">Despacho: {formatarDataDespacho(order.DATADESPACHO)}</span>}
                              {order.BUFFERING_DATE && <span className="tb tb-red">Retida até: {formatarDataDespacho(order.BUFFERING_DATE)}</span>}
                            </div>
                          </td>
                        </tr>

                        {/* ── Painel expandido ── */}
                        {orderMoreAction[index] && (
                          <tr className="tn-exp-row">
                            <td colSpan={12} style={{ padding: 0 }}>
                              <div className="tn-more">
                                <span className="tn-more-lbl">Ações adicionais</span>
                                <div className="tn-sep" />
                                <Tooltip title="Estorno Parcial"><button className="tn-btn" onClick={() => handleParcial(order.PEDIDO)}><Package size={11} /></button></Tooltip>
                                <Tooltip title="Histórico e Andamentos"><button className="tn-btn" onClick={() => handleHistorico(order.PEDIDO)}><FileText size={11} /></button></Tooltip>
                                <Tooltip title="Recadastrar Cliente via API"><button className="tn-btn" onClick={() => handleRecadastrar(order.PEDIDO)}><User size={11} /></button></Tooltip>
                                <Tooltip title="Organizar Envios Shopee"><button className="tn-btn" onClick={() => handleShopee(order.IDPEDIDOLOJA, order.ID_LOJA, order.SHIP)}><QrCode size={11} /></button></Tooltip>
                                <Tooltip title="Reestruturar pedido">
                                  <button
                                    className="tn-btn"
                                    onClick={() => handleEstruturar(order.PEDIDO)}
                                    disabled={loadingEstruturar === order.PEDIDO}
                                  >
                                    {loadingEstruturar === order.PEDIDO ? (
                                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                    ) : (
                                      <RefreshCw size={11} />
                                    )}
                                  </button>
                                </Tooltip>
                                <Tooltip title="Visualizar itens do pedido"><button className="tn-btn" onClick={() => handleOpenModal(order)}><Package size={11} /></button></Tooltip>
                                <Tooltip title="Clonar Pedido"><button className="tn-btn" onClick={() => handleCloneOrder(order)}><Copy size={11} /></button></Tooltip>
                                <Tooltip title={isOrderCopied[order.PEDIDO] ? 'Copiado!' : 'Copiar link de assinatura'}>
                                  <button className="tn-btn" onClick={() => copyLinkSignature(order.PEDIDO)}>
                                    {isOrderCopied[order.PEDIDO] ? <CheckCircle size={11} color="#166534" /> : <Scissors size={11} />}
                                  </button>
                                </Tooltip>
                                <Tooltip title="Navegar até NFe"><button className="tn-btn" onClick={() => handleNfe(order.ID_LOJA, order.ID_NFE)}><FileText size={11} /></button></Tooltip>
                                <div className="tn-sep" />
                                <Tooltip title="Estornar estoque">
                                  <button className="tn-btn tn-ok" onClick={() => handleEstorno(order.PEDIDO)} disabled={!!loadingEstorno[order.PEDIDO]}>
                                    {loadingEstorno[order.PEDIDO] ? <CircularProgress size={10} color="inherit" /> : <Undo size={11} />}
                                  </button>
                                </Tooltip>
                                <Tooltip title="Excluir pedido">
                                  <button className="tn-btn tn-danger" onClick={() => handleDelete(order.PEDIDO)}><Trash2 size={11} /></button>
                                </Tooltip>
                                {localStorage.idconta === '111111111' && (
                                  <Tooltip title="Exportar para Matriz">
                                    <button className="tn-btn" onClick={() => handleExportOrderToBHDatabase(order.PEDIDO, index)} disabled={isExportOrderLoading[index]}>
                                      {isExportOrderLoading[index] ? <CustomSpinner size={10} /> : <Share size={11} />}
                                    </button>
                                  </Tooltip>
                                )}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>

              <div style={{ padding: '10px 14px', borderTop: '1px solid #f3f4f6', background: '#fafafa' }}>
                <Paginate />
              </div>
            </>
          ) : (
            <OrdersTable
              orders={orders} itemsPerPage={itemsPerPage} selectedOrders={selectedOrders}
              handleOrderSelection={handleOrderSelection} orderMoreAction={orderMoreAction}
              setOrderMoreAction={setOrderMoreAction} setShowModal={setShowModal} setPedido={setPedido}
              setShowModalMr={setShowModalMr} getStatusBadgeVariant={getStatusBadgeVariant}
              getBadgeColorForSubstatus={getBadgeColorForSubstatus} statusMap={statusMap}
              formatarDataDespacho={formatarDataDespacho} handleParcial={handleParcial}
              handleHistorico={handleHistorico} handleRecadastrar={handleRecadastrar}
              handleShopee={handleShopee} handleEstruturar={handleEstruturar}
              handleOpenModal={handleOpenModal} handleCloneOrder={handleCloneOrder}
              copyLinkSignature={copyLinkSignature} isOrderCopied={isOrderCopied}
              handleNfe={handleNfe} handleEstorno={handleEstorno} loadingEstorno={loadingEstorno}
              handleDelete={handleDelete} handleExportOrderToBHDatabase={handleExportOrderToBHDatabase}
              isExportOrderLoading={isExportOrderLoading} CustomSpinner={CustomSpinner}
            />
          )}
        </div>

        {/* ── Modais ── */}
        <ModalHistoricoPedido show={showModalHist} onHide={handleFecharModal} historico={historico} onInformarAndamento={atualizarHistorico} pedido={pedido} />

        {/* Modal alterar status */}
        <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="tn-modal">
          <Modal.Header closeButton>
            <Modal.Title>Alterar status — Pedido <strong style={{ color: '#2563eb' }}>#{pedido}</strong></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <label>Novo status</label>
            <select className="form-select" value={atualizarStatus} onChange={(e) => setAtualizarStatus(e.target.value)}>
              <option value="Em aberto">Em aberto</option>
              <option value="Aguardando">Aguardando</option>
              <option value="Atendido">Atendido</option>
              <option value="Cancelado">Cancelado</option>
              <option value="Ag. conf.">Ag. conferência</option>
              <option value="Ag. Definição">Ag. Definição</option>
              <option value="ERRO IMPRESSAO">Erro de Impressão</option>
              <option value="Em conferência">Em conferência</option>
              <option value="Atrasado">Atrasado</option>
              <option value="Ag. Entrega">Ag. Entrega</option>
              <option value="Ag. Produto">Ag. Produto</option>
              <option value="Ag. Pagamento">Ag. Pagamento</option>
              <option value="Pago">Pago</option>
              <option value="Boleto">Boleto</option>
            </select>
          </Modal.Body>
          <Modal.Footer>
            <CustomButton title="Fechar" onClick={() => setShowModal(false)} />
            <CustomButton title="Atualizar" onClick={handleUpdate} />
          </Modal.Footer>
        </Modal>

        <ModalTable data={dadosDev} showModal={showModalDev} handleClose={handleCloseDev} />

        {/* Modal Shopee */}
        <Modal show={showModalShopee} onHide={() => setShowModalShopee(false)} dialogClassName="tn-modal">
          <Modal.Header closeButton>
            <Modal.Title>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <img src={shopeeLogo} alt="Shopee" style={{ width: 30, height: 30, borderRadius: 4 }} />
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>Envio Shopee</div>
                  <div style={{ fontSize: 11, color: '#6b7280', fontFamily: 'monospace' }}>{idship}</div>
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button className="shopee-action-btn" onClick={handleOrgShopee} disabled={isLoadingS}>
                {isLoadingS && <Spinner animation="border" size="sm" />} Organizar Coleta
              </button>
              <button className="shopee-action-btn" onClick={handleCreateEtqShopee} disabled={isLoadingS}>
                {isLoadingS && <Spinner animation="border" size="sm" />} Criar Etiqueta
              </button>
              <button className="shopee-action-btn" onClick={handleDownloadEtqShopee} disabled={isLoadingS}>
                {isLoadingS && <Spinner animation="border" size="sm" />} Download Etiqueta
              </button>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="tn-btn" style={{ width: 'auto', padding: '0 14px', height: 30, fontSize: 12 }} onClick={() => setShowModalShopee(false)}>Fechar</button>
          </Modal.Footer>
        </Modal>
      </div>

      {isModalRangeDatePickerOpen && (
        <ModalRangeDatePicker
          isOpen={isModalRangeDatePickerOpen}
          onClose={() => setIsModalRangeDatePickerOpen(false)}
          selectedRange={selectedRange}
          setInputValue={setInputValue}
          setSelectedRange={setSelectedRange}
        />
      )}

      {selectedOrder && <ModalProduct order={selectedOrder} modalOpen={modalOpen} handleClose={handleCloseModal} />}
    </>
  )
}

export default OrderListM